import type { MetaDescriptor } from 'react-router'
import type { PageMeta } from './content'

/** Title, description, Open Graph and Twitter tags for a website page. */
export function siteMeta(page: PageMeta): MetaDescriptor[] {
	return [
		{ title: page.title },
		{ name: 'description', content: page.description },
		{ property: 'og:title', content: page.title },
		{ property: 'og:description', content: page.description },
		{ property: 'og:type', content: 'website' },
		{ property: 'og:site_name', content: 'TrueTenant' },
		{ name: 'twitter:card', content: 'summary_large_image' },
		{ name: 'twitter:title', content: page.title },
		{ name: 'twitter:description', content: page.description },
	]
}
